export enum Endpoints {
    /**
     * Public module
     */
    // Pages
	PublicPage = '/pages/:slug',

    // User
    PublicUsersPassword = '/users/password',

    // Companies
    PublicCompanyRegister = '/companies',

        // Contact Form
    PublicContactForm = '/user-contacts',

}

export interface ListParamsDefault {
    page?: number;
    perPage?: number;
    search?: string;
}